import React from "react";
import { PremiumTrialTermsInfoTemplate } from "themes/application/payment/components";

function PremiumTrialTermsInfo(props) {
    return <PremiumTrialTermsInfoTemplate {...props} />;
}

export default PremiumTrialTermsInfo;
